import React from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useRequestData, usePrefs } from 'wsm-common-data';
import VehicleTitle from '../components/VehicleTitle';
import useVehicleViews from '../hooks/useVehicleViews';

const Widget = () => {
	const { deviceType } = useRequestData();
	const prefs = usePrefs();
	const shouldRequestVehicleViews = prefs.enableVehicleViews === 'true';
	const { vehicle } = useSelector((state) => state);
	const { viewsError, viewsData } = useVehicleViews(
		vehicle.vin,
		prefs.vehicleViews_timeFrame,
		shouldRequestVehicleViews
	);
	if (vehicle) {
		let portal;
		const isDesktop = deviceType === 'DESKTOP';
		// Put VehicleTitle component in the sidebar for desktop
		if (isBrowser && isDesktop) {
			const [container] = document.querySelectorAll(
				'.ddc-vehicle-title-sidebar'
			);
			portal = ReactDOM.createPortal(
				<VehicleTitle
					isInSidebar
					vehicleViews={viewsData}
					viewsError={viewsError}
				/>,
				container
			);
		}
		return (
			<>
				<VehicleTitle
					vehicleViews={viewsData}
					viewsError={viewsError}
				/>
				{portal}
			</>
		);
	}
	return null;
};

export default Widget;
